module.exports = __webpack_public_path__ + "static/media/Raleway-ExtraLightItalic.005cfa6d.ttf";